import { StarsButton } from '@ps/web-shared-components';
import React from 'react';

import Arrow from '@swf/core/assets/icons/arrow.svg';

interface Props {
  className?: string;
  onClick?(): void;
}

export const ArrowIcon: React.FC<Props> = ({ onClick = () => undefined, className }) => (
  <StarsButton
    variant="text"
    className={className}
    onClick={onClick}
    icon={<Arrow width={15} height={15} />}
  />
);

export default ArrowIcon;
